import {makeStyles} from '@material-ui/core/styles'
import {reExportedColors, EditModeButton, ImageUploaderModal} from '../../../1elements'
import ViewMode from './ViewMode'
import useEditMode from './useEditMode'

const EditMode = ({data, formikProps, index}) => {
    const classes = useStyles()
    const {editorOpen, setEditorOpen, draftData, setDraftData, handleSave} = useEditMode(data, formikProps, index)

    return (
        <>
            <ViewMode data={formikProps.values.values[index]} />
            <EditModeButton className={classes.editButton} setOnEditMode={setEditorOpen} onEditMode={editorOpen} />
            <div className={classes.backdrop} />
            <ImageUploaderModal open={editorOpen} setOpen={setEditorOpen} imageUrlArray={draftData} setImageUrlArray={setDraftData} pushImageUrlArray={handleSave} />
        </>
    )
}

export default EditMode

const useStyles = makeStyles({
    editButton: {
        position: 'absolute',
        zIndex: 2,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: reExportedColors.LIGHT_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        borderRadius: '50%'
    },
    backdrop: {
        height:"85%",
        width:'89%',
        position: 'absolute',
        top: 28,
        bottom: 0,
        left: 17,
        right: 0,
        backgroundColor: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        opacity: .4,
        borderRadius: 20
    },
})